"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line: no-namespace
var OmniChatSchema;
(function (OmniChatSchema) {
    let MessageType;
    (function (MessageType) {
        MessageType["Image"] = "IMAGE";
        MessageType["Text"] = "TEXT";
        MessageType["Audio"] = "AUDIO";
        MessageType["Voice"] = "VOICE";
        MessageType["Document"] = "DOCUMENT";
        MessageType["File"] = "FILE";
        MessageType["Video"] = "VIDEO";
        MessageType["Location"] = "LOCATION";
        MessageType["Product"] = "PRODUCT";
        MessageType["Variant"] = "VARIANT";
        MessageType["PaymentRequest"] = "PAYMENT_REQUEST";
        MessageType["OrderConfirmation"] = "ORDER_CONFIRMATION";
        MessageType["OrderStatus"] = "ORDER_STATUS";
        MessageType["Collection"] = "COLLECTION";
        MessageType["VCard"] = "VCARD";
        MessageType["MultiVCard"] = "MULTI_VCARD";
        MessageType["SnoozeStart"] = "SNOOZE_START";
        MessageType["SnoozeEnd"] = "SNOOZE_END";
        MessageType["Template"] = "TEMPLATE";
        MessageType["Routing"] = "ROUTING";
        MessageType["OrderPreview"] = "ORDER_PREVIEW";
        MessageType["Grouped"] = "GROUPED";
    })(MessageType = OmniChatSchema.MessageType || (OmniChatSchema.MessageType = {}));
    let MessageStatus;
    (function (MessageStatus) {
        MessageStatus["OutgoingCreated"] = "OUTGOING_CREATED";
        MessageStatus["OutgoingSent"] = "OUTGOING_SENT";
        MessageStatus["OutgoingDelivered"] = "OUTGOING_DELIVERED";
        MessageStatus["OutgoingRead"] = "OUTGOING_READ";
        MessageStatus["OutgoingError"] = "OUTGOING_ERROR";
        MessageStatus["OutgoingSilent"] = "OUTGOING_SILENT";
        MessageStatus["ExternalOutgoingSilent"] = "EXTERNAL_OUTGOING_SILENT";
        MessageStatus["IncomingRecevied"] = "INCOMING_RECEIVED";
        MessageStatus["IncomingRead"] = "INCOMING_READ"; // Read by the salesPerson
    })(MessageStatus = OmniChatSchema.MessageStatus || (OmniChatSchema.MessageStatus = {}));
    let ChatPlatform;
    (function (ChatPlatform) {
        ChatPlatform["Whatsapp"] = "WHATSAPP";
        ChatPlatform["WAB"] = "WAB";
        ChatPlatform["WABSmooch"] = "WAB-SMOOCH";
        ChatPlatform["WabDialog"] = "WAB-DIALOG";
        ChatPlatform["WabDialogApi"] = "WAB-DIALOG-API";
        ChatPlatform["FBMessenger"] = "FBMESSENGER";
        ChatPlatform["Skype"] = "SKYPE";
        ChatPlatform["Email"] = "EMAIL";
        ChatPlatform["Sms"] = "SMS";
        ChatPlatform["Chatclub"] = "CHATCLUB";
        ChatPlatform["WebChat"] = "WEBCHAT";
        ChatPlatform["WabTwilio"] = "WAB-TWILIO";
        ChatPlatform["WabInteraxa"] = "WAB-INTERAXA";
    })(ChatPlatform = OmniChatSchema.ChatPlatform || (OmniChatSchema.ChatPlatform = {}));
    let CustomerSupportRequestType;
    (function (CustomerSupportRequestType) {
        CustomerSupportRequestType["Button"] = "BUTTON";
        CustomerSupportRequestType["Collection"] = "COLLECTION";
        CustomerSupportRequestType["Chat"] = "CHAT";
        CustomerSupportRequestType["Campaign"] = "CAMPAIGN";
    })(CustomerSupportRequestType = OmniChatSchema.CustomerSupportRequestType || (OmniChatSchema.CustomerSupportRequestType = {}));
    let CustomerSupportRequestStatus;
    (function (CustomerSupportRequestStatus) {
        CustomerSupportRequestStatus["Waiting"] = "WAITING";
        CustomerSupportRequestStatus["Contacted"] = "CONTACTED";
        CustomerSupportRequestStatus["Finished"] = "FINISHED";
    })(CustomerSupportRequestStatus = OmniChatSchema.CustomerSupportRequestStatus || (OmniChatSchema.CustomerSupportRequestStatus = {}));
    // export type CustomerGender = 'male' | 'female' | 'neutral' | 'other'
    let CustomerGender;
    (function (CustomerGender) {
        CustomerGender["Male"] = "male";
        CustomerGender["Female"] = "female";
    })(CustomerGender = OmniChatSchema.CustomerGender || (OmniChatSchema.CustomerGender = {}));
    let FreightCalculationMode;
    (function (FreightCalculationMode) {
        // The salesperson will manually calculate and input the shipping costs
        FreightCalculationMode["manual"] = "MANUAL";
        // The salesperson may request the gateway to calculate it, but he or her may change it
        FreightCalculationMode["automatic"] = "AUTOMATIC";
        // The salesperson may request the gateway to calculate it.
        FreightCalculationMode["automaticOnly"] = "AUTOMATIC_ONLY";
        // The shipping cost will be calculated by the backend after the order is saved
        FreightCalculationMode["backend"] = "BACKEND";
    })(FreightCalculationMode = OmniChatSchema.FreightCalculationMode || (OmniChatSchema.FreightCalculationMode = {}));
    let FreightCalculationAdapter;
    (function (FreightCalculationAdapter) {
        FreightCalculationAdapter["correios"] = "CORREIOS";
        FreightCalculationAdapter["ciashop"] = "CIASHOP";
        FreightCalculationAdapter["vtex"] = "VTEX";
    })(FreightCalculationAdapter = OmniChatSchema.FreightCalculationAdapter || (OmniChatSchema.FreightCalculationAdapter = {}));
    /**
     * All possible states reflecting Ciashop Integration
     * - REQUESTED: Client saved a new Ciashop object and the backend is waiting for the oAuth request
     * - CONFIGURED: Oauth token recevied and webhooks are set
     * - QUEUED: The user requested the importation
     * - IMPORTING: Importing Ciashop Products, Variants and customers
     * - READY: All imports are finished and ready for usage
     * - SYNCRONIZING: Sync process is executing
     * - ERROR: Something wen wrong, see property errorDescription for more details
     * - INACTIVATE: Inactivate precess for a integration
     * - INACTIVE: Integration is inactive
     */
    let GatewayIntegrationStatus;
    (function (GatewayIntegrationStatus) {
        GatewayIntegrationStatus["Created"] = "CREATED";
        GatewayIntegrationStatus["Requested"] = "REQUESTED";
        GatewayIntegrationStatus["Configured"] = "CONFIGURED";
        GatewayIntegrationStatus["Queued"] = "QUEUED";
        GatewayIntegrationStatus["Importing"] = "IMPORTING";
        GatewayIntegrationStatus["Ready"] = "READY";
        GatewayIntegrationStatus["Synchronizing"] = "SYNCHRONIZING";
        GatewayIntegrationStatus["Error"] = "ERROR";
        GatewayIntegrationStatus["Sync_Error"] = "SYNC_ERROR";
        GatewayIntegrationStatus["Inactivate"] = "INACTIVATE";
        GatewayIntegrationStatus["Inactive"] = "INACTIVE";
        GatewayIntegrationStatus["Switch_bots"] = "SWITCH_BOTS";
        GatewayIntegrationStatus["Migrated"] = "MIGRATED";
    })(GatewayIntegrationStatus = OmniChatSchema.GatewayIntegrationStatus || (OmniChatSchema.GatewayIntegrationStatus = {}));
    let IntegrationImportationStatus;
    (function (IntegrationImportationStatus) {
        IntegrationImportationStatus["REMOVING_OLD_CUSTOMERS"] = "REMOVING_OLD_CUSTOMERS";
        IntegrationImportationStatus["REMOVING_OLD_PRODUCTS"] = "REMOVING_OLD_PRODUCTS";
        IntegrationImportationStatus["IMPORTING_PRODUCTS"] = "IMPORTING_PRODUCTS";
        IntegrationImportationStatus["IMPORTING_CUSTOMERS"] = "IMPORTING_CUSTOMERS";
    })(IntegrationImportationStatus = OmniChatSchema.IntegrationImportationStatus || (OmniChatSchema.IntegrationImportationStatus = {}));
    let IntegrationType;
    (function (IntegrationType) {
        IntegrationType["WebChat"] = "webchat";
        IntegrationType["Waba"] = "waba";
        IntegrationType["Wab"] = "wab";
        IntegrationType["WabSmooch"] = "wab-smooch";
        IntegrationType["Webhooks"] = "webhooks";
        IntegrationType["Sms"] = "sms";
        IntegrationType["Adyen"] = "adyen";
        IntegrationType["bot"] = "bot";
        IntegrationType["LeadBot"] = "lead-bot";
        IntegrationType["ProductImportSFTP"] = "product-import-sftp";
        IntegrationType["WabTwilio"] = "wab-twilio";
    })(IntegrationType = OmniChatSchema.IntegrationType || (OmniChatSchema.IntegrationType = {}));
    let BundleType;
    (function (BundleType) {
        BundleType["WABHSM"] = "WAB-HSM";
        BundleType["WABNORMAL"] = "WAB-NORMAL";
        BundleType["SMS"] = "SMS";
        BundleType["SMSREPLY"] = "SMSREPLY";
    })(BundleType = OmniChatSchema.BundleType || (OmniChatSchema.BundleType = {}));
    let BundleStatus;
    (function (BundleStatus) {
        BundleStatus["VALID"] = "VALID";
        BundleStatus["BILLED"] = "BILLED";
    })(BundleStatus = OmniChatSchema.BundleStatus || (OmniChatSchema.BundleStatus = {}));
    let BundlePolicy;
    (function (BundlePolicy) {
        BundlePolicy["POST_PAID"] = "POST-PAID";
        BundlePolicy["PRE_PAID"] = "PRE-PAID";
        BundlePolicy["UNLIMITED"] = "UNLIMITED";
    })(BundlePolicy = OmniChatSchema.BundlePolicy || (OmniChatSchema.BundlePolicy = {}));
    let MessageTemplateStatus;
    (function (MessageTemplateStatus) {
        MessageTemplateStatus["Requested"] = "REQUESTED";
        MessageTemplateStatus["Ready"] = "READY";
    })(MessageTemplateStatus = OmniChatSchema.MessageTemplateStatus || (OmniChatSchema.MessageTemplateStatus = {}));
    let MessageTemplateType;
    (function (MessageTemplateType) {
        MessageTemplateType["OngoingChat"] = "ONGOING_CHAT";
        MessageTemplateType["NewChat"] = "NEW_CHAT";
        // Requested by the customer
        MessageTemplateType["Custom"] = "CUSTOM";
    })(MessageTemplateType = OmniChatSchema.MessageTemplateType || (OmniChatSchema.MessageTemplateType = {}));
    let MessageTemplateSubType;
    (function (MessageTemplateSubType) {
        MessageTemplateSubType["OngoingChat"] = "ONGOING_CHAT";
        MessageTemplateSubType["NewChat"] = "NEW_CHAT";
    })(MessageTemplateSubType = OmniChatSchema.MessageTemplateSubType || (OmniChatSchema.MessageTemplateSubType = {}));
    let ChatInternalState;
    (function (ChatInternalState) {
        ChatInternalState["INITIAL"] = "INITIAL";
        ChatInternalState["BOT"] = "BOT";
        ChatInternalState["USER"] = "USER";
        ChatInternalState["TEAM"] = "TEAM";
        ChatInternalState["UNASSIGNED"] = "UNASSIGNED";
        ChatInternalState["FINISHED"] = "FINISHED";
    })(ChatInternalState = OmniChatSchema.ChatInternalState || (OmniChatSchema.ChatInternalState = {}));
    let MessageInternalState;
    (function (MessageInternalState) {
        MessageInternalState["INITIAL"] = "INITIAL";
        MessageInternalState["READY"] = "READY";
    })(MessageInternalState = OmniChatSchema.MessageInternalState || (OmniChatSchema.MessageInternalState = {}));
    let SLARuleType;
    (function (SLARuleType) {
        SLARuleType["ROUT_TO_TEAM"] = "RouteToTeam";
    })(SLARuleType = OmniChatSchema.SLARuleType || (OmniChatSchema.SLARuleType = {}));
    let CustomFieldType;
    (function (CustomFieldType) {
        CustomFieldType["TextField"] = "TEXT_FIELD";
        CustomFieldType["TextArea"] = "TEXT_AREA";
        CustomFieldType["DateField"] = "DATE_FIELD";
        CustomFieldType["Numeric"] = "NUMERIC";
        CustomFieldType["Currency"] = "CURRENCY";
        CustomFieldType["Phone"] = "PHONE";
        CustomFieldType["DropDown"] = "DROPDOWN";
        CustomFieldType["CheckBoxList"] = "CHECKBOX_LIST";
        CustomFieldType["Hyperlink"] = "HYPERLINK";
    })(CustomFieldType = OmniChatSchema.CustomFieldType || (OmniChatSchema.CustomFieldType = {}));
    let CustomFieldResourceType;
    (function (CustomFieldResourceType) {
        CustomFieldResourceType["Customer"] = "CUSTOMER";
    })(CustomFieldResourceType = OmniChatSchema.CustomFieldResourceType || (OmniChatSchema.CustomFieldResourceType = {}));
    /**
     * Campaign module
     */
    let CampaignStatus;
    (function (CampaignStatus) {
        CampaignStatus["Sending"] = "SENDING";
        CampaignStatus["Schedulled"] = "SCHEDULED";
        CampaignStatus["Draft"] = "DRAFT";
        CampaignStatus["Paused"] = "PAUSED";
        CampaignStatus["Finished"] = "FINISHED";
        CampaignStatus["Cancelled"] = "CANCELED";
    })(CampaignStatus = OmniChatSchema.CampaignStatus || (OmniChatSchema.CampaignStatus = {}));
    let CampaignAudienceType;
    (function (CampaignAudienceType) {
        CampaignAudienceType["File"] = "FILE";
        CampaignAudienceType["Filter"] = "FILTER";
        CampaignAudienceType["List"] = "LIST";
    })(CampaignAudienceType = OmniChatSchema.CampaignAudienceType || (OmniChatSchema.CampaignAudienceType = {}));
    let CampaignMessageStatus;
    (function (CampaignMessageStatus) {
        CampaignMessageStatus["Created"] = "CREATED";
        CampaignMessageStatus["Sent"] = "SENT";
        CampaignMessageStatus["Delivered"] = "DELIVERED";
        CampaignMessageStatus["Clicked"] = "CLICKED";
        CampaignMessageStatus["Error"] = "ERROR";
        CampaignMessageStatus["Read"] = "READ";
    })(CampaignMessageStatus = OmniChatSchema.CampaignMessageStatus || (OmniChatSchema.CampaignMessageStatus = {}));
    let URLShortnerType;
    (function (URLShortnerType) {
        URLShortnerType["Campaign"] = "CAMPAIGN";
    })(URLShortnerType = OmniChatSchema.URLShortnerType || (OmniChatSchema.URLShortnerType = {}));
    let AutomatiRedirectType;
    (function (AutomatiRedirectType) {
        AutomatiRedirectType["Sequential"] = "SEQUENTIAL";
        AutomatiRedirectType["LinkToUser"] = "LINK_TO_USER";
        AutomatiRedirectType["NotRedirected"] = "NOT_REDIRECTED";
    })(AutomatiRedirectType = OmniChatSchema.AutomatiRedirectType || (OmniChatSchema.AutomatiRedirectType = {}));
    let FeatureFlagStatus;
    (function (FeatureFlagStatus) {
        FeatureFlagStatus["Alpha"] = "ALPHA";
        FeatureFlagStatus["Ready"] = "READY";
        FeatureFlagStatus["Beta"] = "BETA";
    })(FeatureFlagStatus = OmniChatSchema.FeatureFlagStatus || (OmniChatSchema.FeatureFlagStatus = {}));
    let Feature;
    (function (Feature) {
        Feature["Dashboard"] = "dashboard";
        Feature["DashboardAttendanceTime"] = "dashboardAttendanceTime";
        Feature["DashboardAttendanceTimePerTeams"] = "dashboardAttendanceTimePerTeams";
        Feature["DashboardAttendancePerTeams"] = "dashboardAttendancePerTeams";
        Feature["DashboardAttendance"] = "dashboardAttendance";
        Feature["DashboardAttendanceUsers"] = "dashboardAttendanceUsers";
        Feature["DashboardAttendanceTags"] = "dashboardAttendanceTags";
        Feature["DashboardAttendanceReasons"] = "dashboardAttendanceReasons";
        Feature["DashboardAttendanceTimePerUsers"] = "dashboardAttendanceTimePerUsers";
        Feature["DashboardAttendancePerUsers"] = "dashboardAttendancePerUsers";
        Feature["DashboardAttendanceTeams"] = "dashboardAttendanceTeams";
        Feature["DashboardAttendanceTypePerTeams"] = "dashboardAttendanceTypePerTeams";
        Feature["DashboardAttendanceTypePerUsers"] = "dashboardAttendanceTypePerUsers";
        Feature["DashboardAttendanceUsersPerTeams"] = "dashboardAttendanceUsersPerTeams";
        Feature["DashboardAttendanceTagsPerTeams"] = "dashboardAttendanceTagsPerTeams";
        Feature["DashboardAttendanceReasonsPerTeams"] = "dashboardAttendanceReasonsPerTeams";
        Feature["DashboardWabPerTeams"] = "dashboardWabPerTeams";
        Feature["DashboardWabPerUsers"] = "dashboardWabPerUsers";
        Feature["DashboardSalesPerTeams"] = "dashboardSalesPerTeams";
        Feature["DashboardSalesPerUsers"] = "dashboardSalesPerUsers";
        Feature["DashboardMessageChannels"] = "dashboardMessageChannels";
        Feature["DashboardFBMessengerPerUsers"] = "dashboardFbmessengerPerUsers";
        Feature["DashboardFBMessengerPerTeams"] = "dashboardFbmessengerPerTeams";
        Feature["DashboardWebchatPerTeams"] = "dashboardWebchatPerTeams";
        Feature["DashboardWebchatPerUsers"] = "dashboardWebchatPerUsers";
        Feature["BotMaker"] = "botMaker";
        Feature["BotMakerChannels"] = "botMakerChannels";
        Feature["Campaign"] = "campaign";
        Feature["Help"] = "help";
        Feature["Chat"] = "chat";
        Feature["Products"] = "products";
        Feature["Collections"] = "collections";
        Feature["Orders"] = "orders";
        Feature["Clients"] = "clients";
        Feature["Attendances"] = "attendances";
        Feature["Statitics"] = "statistics";
        Feature["Store"] = "store";
        Feature["Address"] = "addresses";
        Feature["PaymentMethods"] = "paymentMethods";
        Feature["Users"] = "users";
        Feature["Teams"] = "teams";
        Feature["Account"] = "account";
        Feature["Integrations"] = "integrations";
        Feature["Quotes"] = "quotes";
        Feature["AttendanceButton"] = "attendanceButton";
        Feature["Reports"] = "Reports";
        Feature["Preferences"] = "Preferences";
    })(Feature = OmniChatSchema.Feature || (OmniChatSchema.Feature = {}));
    let BotHandlerType;
    (function (BotHandlerType) {
        BotHandlerType["botStateChangeHandler"] = "BOT_STATE_CHANGE_HANDLER";
        BotHandlerType["channelStateChangeHandler"] = "CHANNEL_STATE_CHANGE_HANDLER";
        BotHandlerType["sendToUser"] = "SEND_TO_USER";
        BotHandlerType["sendToTeam"] = "SEND_TO_TEAM";
        BotHandlerType["sendToChannel"] = "SEND_TO_CHANNEL";
        BotHandlerType["remoteApiHandler"] = "REMOTE_API_HANDLER";
        BotHandlerType["closeInteractionHandler"] = "CLOSE_INTERACTION_HANDLER";
        BotHandlerType["textualMessageHandler"] = "TEXTUAL_MESSAGE_HANDLER";
        BotHandlerType["SendGroupedMessageHandler"] = "SEND_GROUPED_MESSAGE";
        BotHandlerType["sendGreetings"] = "SEND_GREETINGS";
        BotHandlerType["errorMessage"] = "ERROR_MESSAGE";
    })(BotHandlerType = OmniChatSchema.BotHandlerType || (OmniChatSchema.BotHandlerType = {}));
})(OmniChatSchema = exports.OmniChatSchema || (exports.OmniChatSchema = {}));
//# sourceMappingURL=Schema.js.map